import styled from 'styled-components';
import {
  desktop_breakpoint_extended,
  sm_desktop_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const HeadingStyles = styled.div`
  margin: 0 0 36px;

  .home-info {
    margin-top: 15px;
    width: 100%;

    .favoriting-heart-container {
      float: right;
    }

    .home-title-card {
      width: 100%;
    }

    .sticker-labels {
      margin-bottom: 8px;
    }

    h1 {
      margin-bottom: 10px;
    }

    .error {
      color: ${Colors.accent.barnDoor.standard};
      font-size: 12px;
    }

    .call-icon {
      height: 18px;
      width: 18px;
      vertical-align: top;

      path {
        fill: ${Colors.primary.claytonBlue.standard};
      }
    }

    .call-link {
      font-family: 'acumin-pro', sans-serif;
      font-size: 18px;
      font-weight: bold;
      line-height: 18px;
      letter-spacing: -0.3px;

      &:link {
        text-decoration: none;
      }
    }

    .see-below span {
      font-family: 'source-sans-pro', sans-serif;
      font-size: 12px;
      color: ${Colors.accent.grey1.standard};
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .home-utilities {
    button {
      background-color: ${Colors.secondary.grey6.standard};
      border: none;
      font-size: 14px;
      line-height: 32px;
      margin-top: 8px;
      &:not(:last-child) {
        margin-right: 8px;
      }
      padding: 0px 12px 0px 8px;
      cursor: pointer;
    }

    svg {
      margin-right: 4px;
      position: relative;
      top: 3px;
    }
  }
  .home-specs-container {
    margin: 20px 0;
  }
  .action-buttons {
    list-style: none;

    .button {
      justify-content: center;

      .icon {
        margin-top: -4px;

        svg g {
          fill: inherit;
        }
      }

      svg {
        margin-right: 8px;

        &.white-fill {
          path {
            fill: ${Colors.primary.white.standard};
          }
        }

        &.down {
          transform: rotate(180deg);
        }

        &.blue-fill {
          path {
            fill: ${Colors.primary.claytonBlue.standard};
          }
        }
      }
    }

    li + li {
      margin-top: 8px;
    }
  }

  .virtual-tour-modal {
    .modal-container {
      width: 90%;
      height: 90%;

      .modal-content {
        height: 100%;
        text-align: center;
      }
      iframe {
        width: 90%;
        height: 100%;
        margin: auto;
      }
    }
  }

  @media screen and (max-width: 350px) {
    .home-specs-container {
      > div {
        flex-wrap: wrap;

        > div {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  @media only screen and (min-width: ${desktop_breakpoint_extended}px) {
    .home-info {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .sticker-labels {
        order: 1;
      }

      .home-title-card {
        order: 2;
      }

      .call-icon {
        height: 20px;
        width: 20px;
      }

      .call-link {
        font-size: 20px;
        line-height: 20px;
      }
    }
  }

  @media only screen and (min-width: ${sm_desktop_breakpoint}px) {
    .modal-container {
      .modal-content {
        overflow: visible;
      }
    }
  }
`;
